import { render, staticRenderFns } from "./controllistBitableReport.vue?vue&type=template&id=55f068c3&scoped=true&"
import script from "./controllistBitableReport.vue?vue&type=script&lang=ts&"
export * from "./controllistBitableReport.vue?vue&type=script&lang=ts&"
import style0 from "./controllistBitableReport.vue?vue&type=style&index=0&id=55f068c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f068c3",
  null
  
)

export default component.exports